import React, { Component } from 'react';
import PropTypes from 'prop-types';

import ChecklistItem from './checklistItem.container';

class ChecklistItemGroup extends Component {
  constructor(props) {
    super(props);
  }

  onSaveChecklistItemAnswer = (checklistItemAnswer) => {
    this.props.saveChecklistItemAnswer(checklistItemAnswer);
  };

  render() {
    var checklistItems = this.props.checklistItems.filter(
      (checklistItem) =>
        checklistItem.checklistItemGroupId === this.props.checklistItemGroup.id
    );
    return (
      <div>
        <h2>{this.props.checklistItemGroup.name}</h2>
        {checklistItems.map((checklistItem) => {
          const checklistItemAnswer = this.props.checklistItemAnswers.find(
            (c) => c.checklistItemId === checklistItem.id
          );
          return (
            <div key={checklistItem.id}>
              <ChecklistItem
                checklistItem={checklistItem}
                checklistItemAnswer={checklistItemAnswer}
                checklistRunId={this.props.checklistRun.id}
                onUpdate={this.onSaveChecklistItemAnswer}
              />{' '}
              <br />
            </div>
          );
        })}
      </div>
    );
  }
}

ChecklistItemGroup.propTypes = {
  checklistItems: PropTypes.array,
  saveChecklistItemAnswer: PropTypes.func,
  checklistItemGroup: PropTypes.object,
  checklistItemAnswers: PropTypes.array,
  checklistRun: PropTypes.object,
};

ChecklistItemGroup.defaultProps = {
  checklistItems: [],
  checklistItemAnswers: [],
  checklistRunId: null,
  checklistRun: null,
};
export default ChecklistItemGroup;



// WEBPACK FOOTER //
// ./src/app/main/checklist/checklistItemGroup.js